// extracted by mini-css-extract-plugin
export default {"nameCell":"agencyList_nameCell__FS2tc","name":"agencyList_name__XoYxK","agencyId":"agencyList_agencyId__FdxBv","floatingEditArea":"agencyList_floatingEditArea__KYgS-"};